// import { createI18n } from 'vue-i18n' //引入vue-i18n组件
// import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js';
import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler';
import messages from './index'
// import { getCurrentInstance } from "vue";

const language = (
    navigator.language && navigator.languages ? navigator.languages[0] : navigator.userLanguage || 'zh'
).toLowerCase().substr(0, 2);

console.log(language)
const i18n = createI18n({
    fallbackLocale: 'en',
    globalInjection: true,
    legacy: false, // you must specify 'legacy: false' option
    locale: language,
    messages,
});

export default i18n